import { useEffect, useRef } from 'react';
import { fabric } from 'fabric';

const useCanvasInitialization = (setCanvas) => {
  const canvasRef = useRef(null);
  const fabricRef = useRef(null); // store Fabric canvas instance

  useEffect(() => {
    if (!canvasRef.current) return;

    // Dispose old canvas if exists
    if (fabricRef.current) {
      fabricRef.current.dispose();
      fabricRef.current = null;
    }

    // Create new Fabric canvas (empty-canvas color follows the app theme)
    const themeBg = getComputedStyle(document.documentElement)
      .getPropertyValue('--page-bg-subtle').trim() || '#f0f0f0';
    const initCanvas = new fabric.Canvas(canvasRef.current, {
      selection: true,
      preserveObjectStacking: true,
      backgroundColor: themeBg,
    });

    fabricRef.current = initCanvas;
    setCanvas(initCanvas);

    // Cleanup on unmount
    return () => {
      if (fabricRef.current) {
        fabricRef.current.dispose();
        fabricRef.current = null;
        setCanvas(null); // reset canvas state
      }
    };
  }, [setCanvas]);

  return canvasRef;
};

export default useCanvasInitialization;
